import {AuthenticationService} from '../services/authentication.service';
import {Injectable} from '@angular/core';
import {HttpRequest, HttpHandler, HttpInterceptor} from '@angular/common/http';
import {CookieService} from 'ngx-cookie-service';
import {timeout} from 'rxjs';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private AUTH_HEADER: string = 'Authorization';

  constructor(private authenticationService: AuthenticationService, private cookieService: CookieService) {
  }

  /**
   * function to add bearer token to request
   * @param req
   * @private
   */
  private addAuthenticationToken(req: HttpRequest<any>): HttpRequest<any> {
    const token = this.cookieService.get('token');
    // If we do not have a token, yet then we should not set the header.
    // Here we could first retrieve the token from where we store it.
    if (!token) {
      return req;
    }
    return req.clone({
      headers: req.headers.set(this.AUTH_HEADER, 'Bearer ' + token)
    });
  }

  /**
   * interceptor to handle authentication
   * @param req
   * @param next
   */
  intercept(req: HttpRequest<any>, next: HttpHandler): any {
    req = this.addAuthenticationToken(req);
    return next.handle(req).pipe(timeout(20000));
  }
}
